export default __webpack_public_path__ + "static/media/lockOpenRight.56c73bba.svg";